import { formatPercent } from '../format';

interface Props {
  label: string;
  value: string;
  hero?: boolean;
  /** Use for values that are two numbers wide, so they don't wrap. */
  compact?: boolean;
  /** Signed change vs the previous period of the same length. */
  delta?: { change: number; higherIsBetter: boolean; text?: string } | null;
  footnote?: string;
}

export function StatTile({ label, value, hero, compact, delta, footnote }: Props) {
  const showDelta = delta && Number.isFinite(delta.change) && delta.change !== 0;
  const isUp = (delta?.change ?? 0) > 0;
  const isGood = delta ? (isUp ? delta.higherIsBetter : !delta.higherIsBetter) : false;
  const valueClass = hero ? 'stat-value hero' : compact ? 'stat-value compact' : 'stat-value';

  return (
    <div className="card stat">
      <span className="stat-label">{label}</span>
      <span className={valueClass}>{value}</span>
      {showDelta ? (
        <span className="stat-delta">
          <span className={isGood ? 'up' : 'down'}>
            {isUp ? '\u25b2' : '\u25bc'} {delta!.text ?? formatPercent(Math.abs(delta!.change), 0)}
          </span>
          vs previous period
        </span>
      ) : (
        <span className="stat-foot">{footnote ?? '\u00a0'}</span>
      )}
    </div>
  );
}
